module.exports = __webpack_public_path__ + "res/26-img_game_bg.090779a97f45d6cc267b695f16436989.png";